// extracted by mini-css-extract-plugin
export var active = "_di-7";
export var container = "_di-0";
export var evenWidth = "_di-4";
export var large = "_di-5";
export var outlet = "_di-8";
export var slide = "_di-2";
export var small = "_di-6";
export var tab = "_di-3";
export var tabs = "_di-1";